import { createFileRoute } from '@tanstack/react-router';
import { ProjectOverviewPage } from '../features/projects/project-overview-page';
export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/overview')({
  component: RouteComponent,
});
function RouteComponent() {
  const { companySlug, projectId } = Route.useParams();
  return <ProjectOverviewPage companySlug={companySlug} projectId={projectId} />;
}
